var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('br'),_c('b-tabs',{staticClass:"block",attrs:{"expanded":""}},[_c('b-tab-item',{attrs:{"label":"LOGIN"}},[_c('login')],1),_c('b-tab-item',{attrs:{"label":"CREATE AN ACCOUNT"}},[_c('register')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }